import { render, staticRenderFns } from "./section-hrv.vue?vue&type=template&id=59d039ae&scoped=true"
import script from "./section-hrv.vue?vue&type=script&lang=js"
export * from "./section-hrv.vue?vue&type=script&lang=js"
import style0 from "./section-hrv.vue?vue&type=style&index=0&id=59d039ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d039ae",
  null
  
)

export default component.exports